var map = {
	"./computer/Holder/MainHolder.vue": [
		"6660",
		"chunk-159d5801"
	],
	"./mobile/Holder/MainHolder.vue": [
		"4a9f",
		"chunk-50574743"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "e54e";
module.exports = webpackAsyncContext;